import { chunkArray, uniquePreserveOrder } from '@/util/array-utils'

export type SelectionBatch = {
  fileIds: string[]
  folderIds: string[]
}

export type BuildSelectionBatchesParams = {
  fileIds?: readonly string[]
  folderIds?: readonly string[]
  maxFileIdsPerBatch: number
  maxFolderIdsPerBatch: number
}

/**
 * Build batches for operations that accept `{ file_ids, folder_ids }`-style selections.
 *
 * IMPORTANT:
 * - Folders are always batched first, then files.
 * - This preserves "folder cascade first" semantics for delete, and is the safest default
 *   when we can't derive descendant relationships from IDs alone.
 */
export function buildSelectionBatchesFoldersFirstThenFiles(params: BuildSelectionBatchesParams): SelectionBatch[] {
  const fileIds = uniquePreserveOrder(params.fileIds ?? [])
  const folderIds = uniquePreserveOrder(params.folderIds ?? [])

  const batches: SelectionBatch[] = []

  for (const folderChunk of chunkArray(folderIds, params.maxFolderIdsPerBatch)) {
    if (folderChunk.length === 0) continue
    batches.push({ folderIds: folderChunk, fileIds: [] })
  }

  for (const fileChunk of chunkArray(fileIds, params.maxFileIdsPerBatch)) {
    if (fileChunk.length === 0) continue
    batches.push({ fileIds: fileChunk, folderIds: [] })
  }

  return batches
}
